export const MAX_NICKNAME_LENGTH = 18;
export const DEFAULT_NICKNAME = 'OPERATOR';

export const sanitizeNickname = (value, fallback = DEFAULT_NICKNAME) => {
  const cleaned = String(value || '')
    .split('')
    .filter(char => {
      const code = char.charCodeAt(0);
      return code > 31 && code !== 127;
    })
    .join('')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, MAX_NICKNAME_LENGTH);

  return cleaned || fallback;
};

export const normalizeProfile = (profile) => {
  if (!profile) return profile;

  return {
    ...profile,
    nickname: sanitizeNickname(profile.nickname),
  };
};

export const getProfileNickname = (profile, fallback = DEFAULT_NICKNAME) => {
  return sanitizeNickname(profile?.nickname, fallback);
};
